import { __extends } from "tslib";
import { CompositeTask } from './tasks/CompositeTask';
import { FilterBase } from './FilterBase';
import { ContextGLBlendFactor } from '../base/ContextGLBlendFactor';
var CompositeFilter = /** @class */ (function (_super) {
    __extends(CompositeFilter, _super);
    function CompositeFilter(blendMode, exposure) {
        if (exposure === void 0) { exposure = 1; }
        var _this = _super.call(this) || this;
        _this._compositeTask = new CompositeTask(blendMode, exposure);
        _this.addTask(_this._compositeTask);
        return _this;
    }
    Object.defineProperty(CompositeFilter.prototype, "blendDst", {
        get: function () {
            return ContextGLBlendFactor.ONE_MINUS_SOURCE_ALPHA;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompositeFilter.prototype, "requireBlend", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompositeFilter.prototype, "exposure", {
        get: function () {
            return this._compositeTask.exposure;
        },
        set: function (value) {
            this._compositeTask.exposure = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CompositeFilter.prototype, "overlayTexture", {
        get: function () {
            return this._compositeTask.overlayTexture;
        },
        set: function (value) {
            this._compositeTask.overlayTexture = value;
        },
        enumerable: false,
        configurable: true
    });
    return CompositeFilter;
}(FilterBase));
export { CompositeFilter };
